import axios from '@axios';
import HelperService from './HelperService';

const helperService = new HelperService();
const base = '/api/v1/visits';

export default {
  getCalls(offsiteIdentifier) {
    return axios.get(`${base}/offsite-visits/${offsiteIdentifier}`);
  },
  getCall(id) {
    return axios.get(`${base}/single-visit/${id}`);
  },
  cancelCall(id, reason) {
    return axios.post(`${base}/cancel/${id}`, {
      cancellation_reason: reason,
    });
  },
  acceptCall(id) {
    return axios.post(`${base}/accept-visit/${id}`);
  },
  updateWaitingRoomStatus(callId, status) {
    return axios.post(`${base}/call-state/set-visitor-in-waiting-room/${callId}`, status);
  },
};
